<script>
import {HorizontalBar} from 'vue-chartjs';

export default {
    extends: HorizontalBar,
    props: {
        chartData: {
            type: Array,
            required: true
        },
        labels: {
            type: Array,
            required: true
        },
        options: {
            type: Object,
            required: true
        },
        filteredAccommodations: {
            type: Array,
            required: true
        }
    },
    watch: {
        chartData: {
            deep: true,
            handler () {
                this.$data._chart.destroy();
                this.renderChart({ labels: this.labels, datasets: this.chartData }, { ...this.options, onHover: this.showCursor });
            }
        },
    },
    mounted () {
        this.renderChart({ labels: this.labels, datasets: this.chartData }, { ...this.options });
    },
}
</script>



// WEBPACK FOOTER //
// src/components/StatInventoryChart/StatInventoryChart.vue